<template>
  <breadCrumbs title="Time Picker" main="Form Wizards" title1="Time Picker" />

  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header pb-0">
            <h3>Default:</h3>
          </div>
          <div class="card-body">
            <form class="theme-form">
              <div>
                <div class=" clockpicker">
                  <datepicker v-model="time" timePicker />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { ref } from 'vue';
export default {
  components: {
    Datepicker,

  },
  setup() {
    const time = ref({
      hours: new Date().getHours(),
      minutes: new Date().getMinutes()
    });

    return {
      time,
    }
  }
}
</script>
